import {BlinkButton} from "../../core/ui/Button.jsx";

export const MerchantButton = BlinkButton;
